<div class="max-w-screen-xl p-6 mx-auto shadow-lg bg-white/80 backdrop-blur-md rounded-xl">
  <!-- En-tête -->
  <div class="flex items-center justify-between mb-8">
    <h1
      class="inline-flex items-center justify-center px-5 py-1 text-2xl font-medium text-gray-800 cursor-pointer me-2 hover:text-gray-600">
      Gestion des Licences
    </h1>
    <div class="flex items-center space-x-4">
      <div class="px-4 py-2 bg-blue-100 rounded-lg">
        <span class="font-medium text-blue-800">Licences actives: {{ licenceActiveCount }}</span>
      </div>
      <button *ngIf="isSuper_admin" (click)="openLicenceModal()"
        class="px-4 py-2 text-white transition bg-gray-600 rounded-lg hover:bg-gray-800">
        Ajouter une licence
      </button>
    </div>
  </div>

  <!-- Filtres et recherche -->
  <div class="p-4 mb-6 bg-white border border-blue-200 rounded-lg shadow-sm">
    <div class="grid grid-cols-1 gap-4 md:grid-cols-4">
      <!-- Recherche -->
      <div>
        <label class="block mb-2 text-sm font-medium text-gray-800">Recherche</label>
        <input type="text" placeholder="Numéro de licence..." [(ngModel)]="searchTerm"
          class="bg-gray-50 border border-blue-200 text-gray-800 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
      </div>

      <!-- Statut -->
      <div>
        <label class="block mb-2 text-sm font-medium text-gray-800">Statut</label>
        <select [(ngModel)]="statusFilter"
          class="bg-gray-50 border border-blue-200 text-gray-800 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
          <option value="TOUS">Tous les statuts</option>
          <option value="ACTIF">Active</option>
          <option value="EXPIRE">Expirée</option>
          <option value="DESACTIVE">Desactivée</option>
        </select>
      </div>

      <!-- Type de licence -->
      <div>
        <label class="block mb-2 text-sm font-medium text-gray-800">Type</label>
        <select [(ngModel)]="typeFilter"
          class="bg-gray-50 border border-blue-200 text-gray-800 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
          <option value="TOUS">Tous les types</option>
          <option value="PRO">Professionnelle</option>
          <option value="FREE">Gratuite</option>
        </select>
      </div>

      <!-- Boutons d'action -->
      <div class="flex items-end space-x-2">
        <button (click)="applyFilters()" class="w-full px-4 py-2 text-white bg-gray-600 rounded-lg hover:bg-gray-700">
          Appliquer
        </button>
        <button (click)="resetFilters()"
          class="w-full px-4 py-2 text-gray-700 bg-gray-200 rounded-lg hover:bg-gray-300">
          Réinitialiser
        </button>
      </div>
    </div>
  </div>

  <!-- Liste des licences -->
  <div class="p-4 bg-white border border-blue-200 rounded-lg shadow-sm">
    <h2 class="mb-4 text-lg font-semibold text-gray-800">Liste des Licences</h2>

    <div class="overflow-x-auto">
      <table class="w-full text-sm text-left text-gray-800">
        <thead class="text-xs text-gray-700 uppercase bg-gray-100">
          <tr>
            <th class="px-4 py-3">Numéro</th>
            <th class="px-4 py-3">Partenaire</th>
            <th class="px-4 py-3">Type</th>
            <th class="px-4 py-3">Statut</th>
            <th class="px-4 py-3">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let licence of paginatedLicences" class="bg-white border-b hover:bg-gray-50">
            <td class="px-4 py-3 font-medium">{{ licence.numerolicence?licence.numerolicence:"Demande nouvelle" }}</td>
            <td class="px-4 py-3">{{ licence.partenaire?.inspection?.nom }} {{ licence.partenaire?.inspection?"/":"" }}
              {{ licence.partenaire?.nom }} </td>
            <td class="px-4 py-3">
              <span [ngClass]="{
                'bg-purple-100 text-purple-800': licence.isPro,
                'bg-green-100 text-green-800': !licence.isPro
              }" class="text-xs font-medium px-2.5 py-0.5 rounded">
                {{ licence.isPro ? 'PRO' : 'FREE' }}
              </span>
            </td>
            <td class="px-4 py-3">
              <span [ngClass]="{
                'bg-green-100 text-green-800': licence.status === 'ACTIF',
                'bg-red-100 text-red-800': licence.status === 'EXPIRE',
                'bg-yellow-100 text-yellow-800': licence.status === 'SUSPENDED',
                'bg-gray-100 text-gray-800': licence.status === 'DESACTIVE'
              }" class="text-xs font-medium px-2.5 py-0.5 rounded">
                {{ getStatusText(licence.status) }}
              </span>
            </td>
            <td class="px-4 py-3">
              <div class="flex space-x-2">
                <button (click)="viewLicenceDetails(licence)"
                  class="px-3 py-1 text-xs text-white bg-blue-600 rounded hover:bg-blue-700">
                  Voir
                </button>

                <button *ngIf="isSuper_admin" (click)="toggleLicenceStatus(licence)"
                  class="px-3 py-1 text-xs text-white bg-red-600 rounded hover:bg-red-700">
                  Supprimer
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div class="flex items-center justify-between pt-4">
      <span class="text-sm font-normal text-gray-700">
        Affichage de <span class="font-semibold">{{ itemsPerPage }}-{{ totalPagesLicences }}</span>
        sur <span class="font-semibold">{{ totalPagesLicences }}</span>
      </span>
      <div class="inline-flex space-x-2">
        <button (click)="previousPage()" [disabled]="currentPage === 1"
          class="flex items-center justify-center h-8 px-3 text-sm font-medium text-gray-800 bg-white border border-gray-300 rounded-lg hover:bg-gray-100">
          Précédent
        </button>
        <span *ngFor="let page of visiblePages" (click)="goToPage(page)" [ngClass]="{
          'bg-blue-50 text-blue-600 border-blue-300': currentPage === page,
          'bg-white text-gray-800 border-gray-300': currentPage !== page
        }" class="flex items-center justify-center h-8 px-3 text-sm font-medium border rounded-lg cursor-pointer">
          {{ page }}
        </span>
        <button (click)="nextPage()" [disabled]="currentPage === totalPages"
          class="flex items-center justify-center h-8 px-3 text-sm font-medium text-gray-800 bg-white border border-gray-300 rounded-lg hover:bg-gray-100">
          Suivant
        </button>
      </div>
    </div>
  </div>

  <div class="p-4 mt-6 bg-white border border-blue-200 rounded-lg shadow-sm">
    <h2 class="mb-4 text-lg font-semibold text-gray-800">Liste des Demande de Licence</h2>

    <div class="overflow-x-auto">
      <table class="w-full text-sm text-left text-gray-800">
        <thead class="text-xs text-gray-700 uppercase bg-gray-100">
          <tr>
            <th class="px-4 py-3">Numéro</th>
            <th class="px-4 py-3">Partenaire</th>
            <th class="px-4 py-3">Date de soumission</th>
            <th class="px-4 py-3">Type</th>
            <th class="px-4 py-3">Statut</th>
            <th class="px-4 py-3">Type de demande</th>
            <th class="px-4 py-3">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let licence of demandeLicences" class="bg-white border-b hover:bg-gray-50">
            <td class="px-4 py-3 font-medium">{{ licence.numerolicence?licence.numerolicence:"Demande nouvelle" }}</td>
            <td class="px-4 py-3">{{ licence.utilisateur?.inspection.nom }}</td>
            <td class="px-4 py-3">{{ licence.dateSoumission }}</td>
            <td class="px-4 py-3">
              <span [ngClass]="{
                'bg-purple-100 text-purple-800': licence.typeLicence=='PRO',
                'bg-green-100 text-green-800': licence.typeLicence=='FREE'
              }" class="text-xs font-medium px-2.5 py-0.5 rounded">
                {{ licence.typeLicence=='PRO' ? 'PRO' : 'FREE' }}
              </span>
            </td>
            <td class="px-4 py-3">
              <span [ngClass]="{
                'bg-green-100 text-green-800': licence.status === 'ACTIVE',
                'bg-red-100 text-red-800': licence.status === 'EXPIRED',
                'bg-yellow-100 text-yellow-800': licence.status === 'SUSPENDED',
                'bg-gray-100 text-gray-800': licence.status === 'INACTIVE'
              }" class="text-xs font-medium px-2.5 py-0.5 rounded">
                {{ getStatusText(licence.statutDemande) }}
              </span>
            </td>
            <td class="px-4 py-3">{{ licence.typeDemande }}</td>
            <td class="px-4 py-3">
              <div class="flex space-x-2">
                <button (click)="onpenCreateLicenceModal(licence)"
                  class="px-3 py-1 text-xs text-white bg-blue-600 rounded hover:bg-blue-700">
                  Voir
                </button>

                <button *ngIf="!isSuper_admin" (click)="toggleDemandeLicenceStatus(licence)" [ngClass]="licence.status === 'INACTIVE'
                    ? 'bg-green-600 hover:bg-green-700'
                    : 'bg-red-600 hover:bg-red-700'" class="px-3 py-1 text-xs text-white rounded">
                  Supprimer
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div class="flex items-center justify-between pt-4">
      <span class="text-sm font-normal text-gray-700">
        Affichage de <span class="font-semibold">{{ itemsPerPage }}-{{ totalItems }}</span>
        sur <span class="font-semibold">{{ totalItems }}</span>
      </span>
      <div class="inline-flex space-x-2">
        <button (click)="previousPage()" [disabled]="currentPage === 1"
          class="flex items-center justify-center h-8 px-3 text-sm font-medium text-gray-800 bg-white border border-gray-300 rounded-lg hover:bg-gray-100">
          Précédent
        </button>
        <span *ngFor="let page of [].constructor(totalPages); let i = index" (click)="goToPage(page)" [ngClass]="{
          'bg-blue-50 text-blue-600 border-blue-300': currentPage === page,
          'bg-white text-gray-800 border-gray-300': currentPage !== page
        }" class="flex items-center justify-center h-8 px-3 text-sm font-medium border rounded-lg cursor-pointer">
          {{ i+1 }}
        </span>
        <button (click)="nextPage()" [disabled]="currentPage === totalPages"
          class="flex items-center justify-center h-8 px-3 text-sm font-medium text-gray-800 bg-white border border-gray-300 rounded-lg hover:bg-gray-100">
          Suivant
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal de détails de licence -->
<div *ngIf="showcreateLicenceModal" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
  <div class="w-full max-w-4xl p-6 mx-4 bg-white border border-gray-200 rounded-lg shadow-lg">
    <div class="flex items-center justify-between mb-6">
      <h3 class="text-xl font-semibold text-gray-800">
        {{ selectedLicence?.id ? 'Détails de la demande licence' : 'Nouvelle demande licence' }}
      </h3>
      <button (click)="closeCreateLicenceModal()" class="text-gray-500 hover:text-gray-700">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>

    <form class="grid grid-cols-1 gap-6 md:grid-cols-2">
      <!-- Colonne 1 -->
      <div class="space-y-4">

        <div>
          <label class="block mb-2 text-sm font-medium text-gray-800">Partenaire</label>
          <input type="text" name="nomPartenaire" [readOnly]="!isSuper_admin"
            [(ngModel)]="selectedLicence.utilisateur.inspection.nom"
            class="bg-gray-50 border border-blue-200 text-gray-800 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
        </div>

        <div>
          <label class="block mb-2 text-sm font-medium text-gray-800">Type de demande</label>
          <input type="text" name="typeDemande" [readOnly]="!isSuper_admin" [(ngModel)]="selectedLicence.typeDemande"
            class="bg-gray-50 border border-blue-200 text-gray-800 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
        </div>
      </div>

      <!-- Colonne 2 -->
      <div class="space-y-4">
        <div>
          <label class="block mb-2 text-sm font-medium text-gray-800">Statut</label>
          <select name="statutDemande" [(ngModel)]="selectedLicence.statutDemande"
            class="bg-gray-50 border border-blue-200 text-gray-800 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
            <option value="EN_TRAITEMENT">En Traitement</option>
            <option value="EN_ATTENTE">En attente</option>
            <option value="APPROUVEE">Approuvé</option>
            <option value="REJETEE">Rejeté</option>
          </select>
        </div>

        <div class="flex space-x-4">
          <div class="flex items-center">
            <input type="checkbox" [readOnly]="!isSuper_admin" name="isLicencePro"
              [ngModel]="selectedLicence.typeLicence === 'PRO'" id="isPro"
              class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500">
            <label for="isPro" class="ml-2 text-sm font-medium text-gray-800">Licence Pro</label>
          </div>

          <div class="flex items-center">
            <input type="checkbox" [readOnly]="!isSuper_admin" name="isLicenceFree"
              [ngModel]="selectedLicence.typeLicence === 'FREE'" id="isFree"
              class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500">
            <label for="isFree" class="ml-2 text-sm font-medium text-gray-800">Licence Gratuite</label>
          </div>
        </div>


      </div>
    </form>

    <div class="flex justify-end mt-6 space-x-3">
      <button (click)="closeCreateLicenceModal()"
        class="px-4 py-2 text-gray-700 bg-gray-200 border border-gray-300 rounded-lg hover:bg-gray-300">
        Annuler
      </button>
      <button (click)="updateDemandeLicence()" *ngIf="isSuper_admin"
        class="px-4 py-2 text-white bg-gray-600 border border-gray-700 rounded-lg hover:bg-gray-700 disabled:opacity-50">
        {{ selectedLicence?.id ? 'Modifier' : 'Créer' }}
      </button>
    </div>
  </div>
</div>

<div *ngIf="showLicenceModal" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
  <div class="w-full max-w-xl p-6 mx-4 bg-white border border-gray-200 rounded-lg shadow-lg">
    <div class="flex items-center justify-between mb-6">
      <h3 class="text-xl font-semibold text-gray-800">
        {{ licence.id ? "Modifier une licence" : "Créer une licence" }}
      </h3>
      <button (click)="closeLicenceModal()" class="text-gray-500 hover:text-gray-700">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>

    <form class="grid grid-cols-1 gap-6 md:grid-cols-1">
      <!-- Colonne 1 -->
      <div class="space-y-2">
        <div *ngIf="usersByInspection.length==0" class="flex flex-col items-center justify-center py-8">
          <div class="relative">
            <div class="w-12 h-12 border-4 border-blue-200 rounded-full"></div>
            <div
              class="absolute top-0 left-0 w-12 h-12 border-4 border-blue-600 rounded-full animate-spin border-t-transparent">
            </div>
          </div>
          <p class="mt-3 text-sm text-gray-600">Chargement des partenaires...</p>
        </div>
        <div *ngIf="usersByInspection && usersByInspection.length > 0">
          <label for="patenaire" class="block mb-2 text-sm font-medium text-blue-800">Partenaire</label>
          <select id="patenaire" [(ngModel)]="selectedPartenaire" name="patenaire"
            class="bg-gray-50 border border-blue-200 text-gray-800 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
            <option value="-1">Sélectionner le partenaire</option>
            <option *ngFor="let patenaire of usersByInspection" [value]="patenaire.id">{{ patenaire.nom }} {{
              patenaire.prenom }}</option>
          </select>

        </div>
        <div>
          <label class="block mb-2 text-sm font-medium text-gray-800">Nombre de jour de grâce</label>
          <input type="number" name="gracedays" [(ngModel)]="licence.graceDays"
            class="bg-gray-50 border border-blue-200 text-gray-800 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
        </div>

        <div>
          <label class="block mb-2 text-sm font-medium text-gray-800">Pays</label>
          <select name="pays" [(ngModel)]="licence.pays"
            class="bg-gray-50 border border-blue-200 text-gray-800 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
            <option *ngFor="let pays of paysArray" [value]="pays">{{ pays }}</option>
          </select>
        </div>
        <div class="flex space-x-4">
          <div class="flex items-center">
            <input type="checkbox" name="isLicencePro" [(ngModel)]="licence.isPro" id="isPro"
              class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500">
            <label for="isPro" class="ml-2 text-sm font-medium text-gray-800">Licence Pro</label>
          </div>

          <div class="flex items-center">
            <input type="checkbox" name="isLicenceFree" [(ngModel)]="licence.isFree" id="isFree"
              class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500">
            <label for="isFree" class="ml-2 text-sm font-medium text-gray-800">Licence Gratuite</label>
          </div>
        </div>
      </div>


    </form>

    <div class="flex justify-end mt-6 space-x-2">
      <button (click)="closeLicenceModal()"
        class="px-4 py-2 text-gray-700 bg-gray-200 border border-gray-300 rounded-lg hover:bg-gray-300">
        Annuler
      </button>
      <button (click)="saveLicence()"
        class="px-4 py-2 text-white bg-gray-600 border border-gray-700 rounded-lg hover:bg-gray-700 disabled:opacity-50">
        {{ licence.id ? "Modifier" : "Créer" }}
      </button>
    </div>
  </div>
</div>


<!-- Modal de confirmation -->
<div *ngIf="showConfirmationModal" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
  <div class="p-6 bg-white border border-gray-200 rounded-lg shadow-lg w-96">
    <h3 class="mb-4 text-xl font-semibold text-gray-800">Confirmer l'action</h3>
    <p class="text-gray-600">
      Êtes-vous sûr de vouloir Supprimer cette {{ deleteLicence? 'licence' : 'Demande de licence' }} ?
    </p>
    <div class="flex justify-end mt-6 space-x-3">
      <button (click)="showConfirmationModal = false"
        class="px-4 py-2 text-gray-700 bg-gray-200 border border-gray-300 rounded-lg hover:bg-gray-300">
        Annuler
      </button>
      <button (click)="confirmToggleStatus()"
        class="px-4 py-2 text-white bg-red-600 border border-red-700 rounded-lg hover:bg-red-700">
        Confirmer
      </button>
    </div>
  </div>
</div>
